module.exports = __webpack_public_path__ + "img/signo-de-exclamacion.7eed2545.png";